// src/pages/Unban.js
import React, { useState } from 'react';
import { Button, Container, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './PageStyles.css';

const Unban2 = () => {
  const [userId, setUserId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleUnban = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await axios.post('https://api.malevich.sverhum.ru/apivk', {
        method: 'unban',
        id: userId,
      }, {
        headers: { 'Content-Type': 'application/json' },
      });

      setSuccess('Пользователь успешно разбанен');
    } catch (error) {
      setError('Ошибка при выполнении запроса');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-4">
      <div className="back-button-container">
        <Button variant="secondary" onClick={() => navigate('/admin2')}>Вернуться назад</Button>
      </div>
      <div className="d-flex flex-column align-items-center">
        <h1>Разбан пользователя</h1>
        <Form onSubmit={handleUnban}>
          <Form.Group controlId="unban-user">
            <Form.Label>Введите ID пользователя</Form.Label>
            <Form.Control
              type="text"
              placeholder="Введите id"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit" className="mt-3" disabled={loading}>
            {loading ? 'Разбан...' : 'Разбанить'}
          </Button>
        </Form>
        {error && <p className="text-danger mt-3">{error}</p>}
        {success && <p className="text-success mt-3">{success}</p>}
      </div>
    </Container>
  );
};

export default Unban2;
